<template>

  <v-app id="app">

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-dialog v-model="contactDialog" persistent max-width="600">

      <v-card>

        <v-card-title class="text-h5"><strong>Contact Us</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>If you have any questions or comments, please feel free to contact us.</p>

          <p>Email: <a :href="supportEmailUrl">{{ supportEmail }}</a></p>

          <p>Phone: {{ supportPhone }}</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="contactDialog = false" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-app-bar color="primary white--text" app>

      <router-link to="/"><v-img class="shrink mr-2" :src="logoUrl" width="250" /></router-link>

      <v-spacer></v-spacer>

      <h2 class="d-none d-lg-flex">Open Burning Registration System</h2>

      <v-spacer></v-spacer>

      <v-btn class="white--text d-none d-sm-flex" text @click="navigateToDashboard" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">dashboard</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="navigateToOrders" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">orders</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="navigateToFinancials" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">financials</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="navigateToChangeLogs" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">change logs</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="navigateToExceptions" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">exceptions</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="navigateToForm" v-if="$store.state.user.role == 'User'">dashboard</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="navigateToCart" v-if="$store.state.user.role == 'User'"><v-icon left>mdi-cart</v-icon>cart</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="contact" v-if="$store.state.user.role != 'Admin'">contact us</v-btn>

      <v-btn class="white--text d-none d-sm-flex" text @click="signout" v-if="$store.state.user.email != null">sign out</v-btn>

      <v-app-bar-nav-icon class="white--text d-flex d-sm-none" @click.stop="drawer = !drawer" bottom v-if="$store.state.user.email != null"></v-app-bar-nav-icon>

    </v-app-bar>

    <v-navigation-drawer v-model="drawer" temporary app>

      <v-list nav dense>

        <v-list-item-content>

          <v-list-item key="1" @click="navigateToDashboard" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-list-item-title>Dashboard</v-list-item-title>

          </v-list-item>

          <v-list-item key="2" @click="navigateToOrders" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-list-item-title>Orders</v-list-item-title>

          </v-list-item>

          <v-list-item key="3" @click="navigateToFinancials" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-list-item-title>Financials</v-list-item-title>

          </v-list-item>

          <v-list-item key="4" @click="navigateToChangeLogs" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-list-item-title>Change Logs</v-list-item-title>

          </v-list-item>

          <v-list-item key="5" @click="navigateToExceptions" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-list-item-title>Exceptions</v-list-item-title>

          </v-list-item>

          <v-list-item key="6" @click="navigateToForm" v-if="$store.state.user.role == 'User'">

            <v-list-item-title>Dashboard</v-list-item-title>

          </v-list-item>

          <v-list-item key="7" @click="navigateToCart" v-if="$store.state.user.role == 'User'">

            <v-list-item-title>Cart</v-list-item-title>

          </v-list-item>

          <v-list-item key="8" @click="contact" v-if="$store.state.user.role == 'User'">

            <v-list-item-title>Contact Us</v-list-item-title>

          </v-list-item>

          <v-list-item key="9" @click="signout" v-show="$store.state.user.email != null">

            <v-list-item-title>Sign Out</v-list-item-title>

          </v-list-item>

        </v-list-item-content>

      </v-list>

    </v-navigation-drawer>

    <v-main>

      <div>

        <h2 class="hidden-lg-and-up text-center">Open Burning Registration System</h2>

      </div>

      <v-container fluid>

        <router-view></router-view>

      </v-container>

    </v-main>

    <v-footer>

      <v-layout justify-center>

        <span class="caption" style="font-family: Nunito !important; font-size: 14px !important;"><strong>Open Burning Registration System</strong> (Version 2.1.1) - Copyright @ Metro Vancouver 2023 | <a href="https://metrovancouver.org/Documents/copyright-notice-disclaimer.pdf" target="_blank" style="font-family: Nunito !important; font-size: 14px !important;">Copyright Notice & Disclaimer</a>

        </span>

      </v-layout>

    </v-footer>

  </v-app>

</template>

<script lang="ts">

import Vue from 'vue';
import axios from "axios";

export default Vue.extend({

  name: 'App',

  data: () => ({

    overlay: false,

    drawer: false,

    logoUrl: '',

    contactDialog: false,

    supportEmail: '',

    supportEmailUrl: '',

    supportPhone: ''

  }),

  created()
  {
    this.supportEmail = process.env.VUE_APP_SUPPORT_EMAIL;

    this.supportEmailUrl = 'mailto:' + process.env.VUE_APP_SUPPORT_EMAIL;

    this.supportPhone = process.env.VUE_APP_SUPPORT_PHONE;

    this.logoUrl = process.env.VUE_APP_ROOT_API + "/images/mv-logo.png";
  },

  methods: {

    async contact() {

      this.contactDialog = true;

    },

    async signout() {

      this.overlay = true;

      setTimeout(async () => {

        let obj = await axios.get('accounts/sign-out');

        this.overlay = false;

        if (obj.data == '%%SUCCESS%%') {

          this.$store.dispatch('updateEmail', null);

          this.$store.dispatch('updateRole', null);

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 100);

    },

    async navigateToDashboard() {

      if (this.$route.path != '/Dashboard') this.$router.push('/Dashboard');

    },

    async navigateToFinancials() {

      if (this.$route.path != '/Financials') this.$router.push('/Financials');

    },

    async navigateToOrders() {

      if (this.$route.path != '/Orders') this.$router.push('/Orders');

    },

    async navigateToChangeLogs() {

      if (this.$route.path != '/ChangeLogs') this.$router.push('/ChangeLogs');

    },

    async navigateToExceptions() {

      if (this.$route.path != '/Exceptions') this.$router.push('/Exceptions');

    },

    async navigateToCart() {

      if (this.$route.path != '/Cart') this.$router.push('/Cart');

    },

    async navigateToForm() {

      if (this.$route.path != '/Form') this.$router.push('/Form');

    }

  }

});

</script>

<style>

.word-break {

  word-break: break-word;

}

.container {

  max-width: 1800px;

}

#app {

  background-color: #F2F4F4;

  color: #222222;

  font-family: Nunito;

}

</style>

<style lang="sass">

@import '../node_modules/typeface-nunito/index.css'

</style>
